 import {grayColor} from "../../material-dashboard-pro-react";
import {withStyles} from "@mui/styles";
import TableRow from "@mui/material/TableRow";
import {TableCell} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import React from "react";


const advancedSearchStyle = {
    nativeSelect : {
        fontFamily: '"Source Sans Pro",sans-serif',
        fontSize: '14px',
    },
    listItemText : {
        fontFamily: '"Source Sans Pro",sans-serif',
        fontSize: '14px',
        '& .MuiListItemText-primary' :{
            fontFamily: '"Source Sans Pro",sans-serif',
            fontSize: '14px',
        }
    },
    formControlLabel :
    {
        fontFamily: '"Source Sans Pro",sans-serif',
        fontSize: '14px',
        '& .MuiFormControlLabel-label' :{
            fontFamily: '"Source Sans Pro",sans-serif',
            fontSize: '14px',
        }
    },
    modalRoot: {
        overflow: "auto",
        alignItems: "unset",
        justifyContent: "unset"
    },
    modal: {
        borderRadius: "6px",
        marginTop: "100px !important",
        overflow: "visible",
        maxHeight: "unset",
        position: "relative",
        height: "fit-content"
    },
    modalHeader: {
        borderBottom: "none",
        paddingTop: "24px",
        paddingRight: "24px",
        paddingBottom: "0",
        paddingLeft: "24px",
        minHeight: "16.43px"
    },
    modalTitle: {
        margin: "0",
        lineHeight: "1.42857143",
        marginTop: "0.7rem",
        fontSize: "1.3rem",
        fontWeight: "500",
        fontFamily: '"Source Sans Pro",sans-serif',
    },
    modalCloseButton: {
        color: grayColor[0],
        marginTop: "-12px",
        WebkitAppearance: "none",
        padding: "0",
        cursor: "pointer",
        background: "0 0",
        border: "0",
        fontSize: "inherit",
        opacity: ".9",
        textShadow: "none",
        fontWeight: "700",
        lineHeight: "1",
        float: "right"
    },
    modalClose: {
        width: "16px",
        height: "16px"
    },
    modalBody: {
        paddingTop: "24px",
        paddingRight: "24px",
        paddingBottom: "16px",
        paddingLeft: "24px",
        position: "relative",
        overflow: "visible"
    },
    modalFooter: {
        padding: "15px",
        textAlign: "right",
        paddingTop: "0",
        margin: "0"
    },
    modalFooterCenter: {
        marginLeft: "auto",
        marginRight: "auto"
    },
    instructionNoticeModal: {
        marginBottom: "25px"
    },
    imageNoticeModal: {
        maxWidth: "150px"
    },
    modalSmall: {
        width: "300px"
    },
    modalSmallBody: {
        paddingTop: "0"
    },
    modalSmallFooterFirstButton: {
        margin: "0",
        paddingLeft: "16px",
        paddingRight: "16px",
        width: "auto"
    },
    modalSmallFooterSecondButton: {
        marginBottom: "0",
        marginLeft: "5px"
    },
    buttonsModal: {
        fontFamily: '"Source Sans Pro",sans-serif',
        fontWeight: '600',
    },
    compactGridItem:{
        padding: "0 3px !important",
    }
};
export default advancedSearchStyle;

export const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            //  backgroundColor: "#0000001a",

        },
        color: '',
        fontWeight: '600',
        lineHeight: '1.3rem',
        fontFamily: '"Source Sans Pro",sans-serif',
    },
}))(TableRow);
export const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: '#000',
        color: '#fff',
    },
    body: {
        fontSize: 14,
        color: '#585667',
        // fontWeight: '500',
        lineHeight: '1.3rem',
        fontFamily: '"Source Sans Pro",sans-serif',
    },
}))(TableCell);
export const StyledTableHead = withStyles((theme) => ({
    head: {
        backgroundColor: '#9798a0',
        fontFamily: "'Sans source pro',sans-serif",
        fontWeight: 400,
        color: '#ffffff',
    },
}))(TableCell);
export const StyledTableFooter = withStyles((theme) => ({
    footer: {
        fontFamily: "'Sans source pro',sans-serif",
        fontWeight: 400,
        color: '#000000de',
    },
}))(TableRow);
export const StyledCheckbox = withStyles({
    root: {
        color: "#4a4856",
        '&$checked': {
            color: "#91c241",
        },
    },
    checked: {}
})((props) => <Checkbox color="default" {...props} />);

